import React, {useState} from "react";
import "./SignUp.css";
import {signUp, signIn} from "../../services/users";
import {useHistory} from "react-router-dom";
import Layout from "../../components/shared/Layout/Layout";

const SignUp = (props) => {
  const history = useHistory();

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    passwordConfirmation: "",
    isError: false,
    errorMsg: "",
  });

  const handleChange = (event) =>
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });

  const onSignUp = (event) => {
    event.preventDefault();
    const {setUser} = props;

    signUp(form)
      .then(() => signIn(form))
      .then((user) => setUser(user))
      .then(() => history.push("/"))
      .catch((error) => {
        console.error(error);
        setForm({
          email: "",
          password: "",
          passwordConfirmation: "",
          isError: true,
          errorMsg: "Sign Up Details Invalid",
        });
      });
  };

  const renderError = () => {
    const toggleForm = form.isError ? "danger" : "";
    if (form.isError) {
      return (
        <button type="submit" className={toggleForm}>
          {form.errorMsg}
        </button>
      );
    } else {
      return <button type="submit">Sign Up</button>;
    }
  };

  const {email, username, password, passwordConfirmation} = form;

  return (
    <Layout user={props.user}>
      <div className="signup-container">
        <div className="form-container-signup">
          <h3>Sign Up</h3>
          <form onSubmit={onSignUp}>
            <input
              required
              type="text"
              name="username"
              value={username}
              placeholder="Enter username"
              autoComplete="username"
              onChange={handleChange}
            />
            <input
              required
              type="email"
              name="email"
              value={email}
              placeholder="Enter email"
              autoComplete="email"
              onChange={handleChange}
            />
            <input
              required
              name="password"
              value={password}
              type="password"
              placeholder="Password"
              autoComplete="password"
              onChange={handleChange}
            />
            <input
              required
              name="passwordConfirmation"
              value={passwordConfirmation}
              type="password"
              placeholder="Confirm Password"
              autoComplete="passwordConfirmation"
              onChange={handleChange}
            />
            {renderError()}
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default SignUp;
